import { Box, MenuItem, Select, Typography, useTheme } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getUserFullname } from 'functions/user';
import { updateUserData } from 'redux/slices/user';
import { useAppSelector } from 'redux/hooks';

import { IOrganization, IUser, IUserResponse } from 'types/models/User';

interface UserInfoBlockProps {
  organizations?: IOrganization[];
}

/**
 * Информация о пользователе в сайдбаре
 */
export const UserInfoBlock: FC<UserInfoBlockProps> = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { data: userData } = useAppSelector(state => state.eventUser) as { data: IUser | null };
  const [selectedOrgId, setSelectedOrgId] = useState<string>('');

  useEffect(() => {
    if (userData?.organization?.id) {
      setSelectedOrgId(userData.organization.id);
    }
  }, [userData?.organization?.id]);

  const fullName = userData ? getUserFullname({
    firstName: userData.first_name,
    lastName: userData.last_name,
    middleName: userData.middle_name
  }) : '';

  /**
   *
   * @param organizationId
   */
  const handleChangeOrganization = async (organizationId: string) => {
    const fullOrganizationData = userData?.organizations.find(org => org.id === organizationId);
    if (fullOrganizationData && userData) {
      const { organization, ...userWithoutOrg } = userData;

      dispatch(updateUserData({
        user: userWithoutOrg as IUserResponse,
        organization: fullOrganizationData
      }));

      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  };

  /**
   * Рендер основного компонента
   */
  const renderContent = () => (
    <Box width={200}>
      {userData?.organizations && userData.organizations.length > 1 ? (
        <Select value={selectedOrgId}
                onChange={e => handleChangeOrganization(e.target.value)}
                fullWidth
                labelId='organization_id'
                variant='standard'
                disableUnderline
                sx={{
                  color: theme.palette.secondary.dark,
                  '& .MuiSelect-select': {
                    padding: '0',
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: 'pointer',
                    '&:hover': { color: theme.palette.primary.main }
                  },
                  '& .MuiSelect-icon': {
                    color: theme.palette.secondary.dark,
                    right: 0,
                    '&:hover': { color: theme.palette.primary.main }
                  },
                  marginBottom: '8px'
                }}>
          {userData.organizations.map(org => (
            <MenuItem key={org.id}
                      value={org.id}
                      sx={{
                        fontSize: 14,
                        '&:hover': { backgroundColor: theme.palette.action.hover }
                      }}>
              {org.name}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Typography marginBottom={1} color='secondary'>
          {userData?.organization?.name}
        </Typography>
      )}
      <Typography marginBottom={1} color='secondary'>
        {fullName}
      </Typography>
      <Typography color='secondary' fontSize='.75rem'>
        {userData?.role.name_human} <br />
      </Typography>
      <Typography color='secondary.light' fontSize='.75rem' marginBottom={5} variant='number'>
        {userData?.email}
      </Typography>
    </Box>
  );

  return renderContent();
};
